import _ from 'lodash';

export const EmptyRenderer = _.constant(null);

export default EmptyRenderer;
